/**
 * UNIVAPLAT-2990: query models for the admin OTP mode endpoints
 * (`/api/v2/admin/users/{userId}/otp-mode*`, backend contract UNIVAPLAT-2977).
 */

/**
 * The two OTP delivery modes an admin can set for a user.
 */
export enum OtpModeEnum {
    STATIC = 'static',
    DYNAMIC = 'dynamic',
}

/**
 * The admin who made an OTP mode change (mirrors the shape of
 * `AdminUserConnection` in `admin-user.model.ts` — kept as a standalone
 * interface here, rather than importing it, to avoid a circular import
 * between the two models now that {@link OtpModeEnum} is referenced from
 * `AdminUser`).
 */
export interface OtpModeChangedBy {
    id: number;
    firstName: string;
    lastName: string;
}

/**
 * A single OTP mode change, as returned by
 * `GET /api/v2/admin/users/{userId}/otp-mode/history` (newest-first).
 *
 * - `staticCode` is populated when `newMode` is {@link OtpModeEnum.STATIC},
 *   null otherwise (e.g. when reverting to dynamic).
 * - `reason` is null unless the admin recorded one when making the change.
 * - `changedAt` is an ISO-8601 (ATOM) string.
 */
export interface OtpModeHistoryEntry {
    changedAt: string;
    previousMode: OtpModeEnum;
    newMode: OtpModeEnum;
    staticCode: string | null;
    reason: string | null;
    changedBy: OtpModeChangedBy;
}
